'use strict';
import { SharedAngular } from '@Client/@types/sharedAngular';
import angular from 'angular';

angular
  .module('flowingly.runner.directives')
  .component('flowTimelineFilelistAttachDocument', {
    bindings: {
      files: '<'
    },
    controller: [
      'sessionService',
      'fileService',
      function (
        sessionService: SharedAngular.SessionService,
        fileService: SharedAngular.FileService
      ) {
        const ctrl = this;
        ctrl.user = sessionService.getUser();

        init();

        function init() {
          for (let f = 0; f < ctrl.files.length; f++) {
            const fileId = ctrl.files[f].FileId;
            ctrl.files[f].DownloadLink = fileId
              ? fileService.getDownloadLink(fileId)
              : undefined;
          }
        }
      }
    ],
    template: `
                    <div ng-repeat="file in $ctrl.files">
                        <a flow-download-link="{{::file.DownloadLink}}" title="{{::file.FileName}}" target="_blank"> {{::file.FileName}}</a>                                               
                    </div>
                `
  });
